import React from "react";
import { Button } from "@mui/material";
import { getImageImageEndPoint } from "../../../../api/image";

const ImageDownloadButton = ({ image }) => {
  const handleDownload = async () => {
    const imageUrl = getImageImageEndPoint(image.imageEntityId, image.version);

    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${image.imageName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading image:", error);
    }
  };

  return (
    <Button
      onClick={handleDownload}
      variant="contained"
    >
      Download
    </Button>
  );
};

export default ImageDownloadButton;
